import React, { Component } from "react";

class Loading extends Component {
  render() {
    return (
      <div className={`row align-items-center w-100 ${this.props.fixed ? 'the-loader' :null}`} >
        <img src="/assets/images/loader.gif" alt="loader" className="m-auto" />
      </div>
    );
  }
}

export default Loading;
